import { Link } from "react-router-dom";
import { ArrowRight, Code2, CreditCard, Home, Search } from "lucide-react";
import { AgentLayout } from "@/components/agent/AgentLayout";
import { PageHeader } from "@/components/agent/ui";
import { SettingsCard } from "@/components/ui/settings-card";
import { HELP_TOPICS } from "@/lib/searchIndex";
const isMac = typeof navigator !== "undefined" && /Mac|iPhone|iPad/.test(navigator.platform);
const GUIDES = [
  { to: "/lets/new", icon: Home, title: "Add a property", text: "Set the rent, move-in date and who you'll accept." },
  { to: "/developers#property-keys", icon: Code2, title: "Put Apply on your website", text: "One button per property, from your property keys." },
  { to: "/billing/plans", icon: CreditCard, title: "Compare plans", text: "Pay as you go, Starter or Pro." },
];
export default function Help() {
  return (
    <AgentLayout>
      <PageHeader title="Help" description="Answers to the questions agents ask most, and where to find things." />
      <div className="grid gap-3 sm:grid-cols-3" data-testid="help-guides">
        {GUIDES.map(({ to, icon: Icon, title, text }) => (
          <Link key={to} to={to} className="group flex flex-col gap-3 rounded-xl border bg-background p-4 transition-colors hover:bg-panel" data-testid={`help-guide-${to}`}>
            <span className="grid size-8 place-items-center rounded-lg bg-muted text-muted-foreground"><Icon className="size-4" /></span>
            <span>
              <span className="flex items-center gap-1 text-sm font-medium">{title}<ArrowRight className="size-3.5 opacity-0 transition-opacity group-hover:opacity-100" /></span>
              <span className="mt-0.5 block text-xs text-muted-foreground">{text}</span>
            </span>
          </Link>
        ))}
      </div>
      <SettingsCard title="Common questions" flush testid="help-topics">
        {HELP_TOPICS.map((t) => (
          <div key={t.id} id={t.id} className="border-t px-4 py-4 first:border-t-0" data-testid={`help-topic-${t.id}`}>
            <h3 className="text-sm font-medium">{t.title}</h3>
            <p className="mt-1 text-sm text-muted-foreground">{t.text}</p>
          </div>
        ))}
      </SettingsCard>
      <SettingsCard testid="help-search">
        <div className="flex items-center gap-3">
          <span className="grid size-8 shrink-0 place-items-center rounded-lg bg-muted text-muted-foreground"><Search className="size-4" /></span>
          <p className="flex-1 text-sm text-muted-foreground">
            Looking for a setting? Press <kbd className="rounded border px-1.5 font-sans text-xs text-foreground">{isMac ? "⌘" : "Ctrl "}K</kbd> anywhere to search every page, setting and property.
          </p>
        </div>
      </SettingsCard>
    </AgentLayout>
  );
}
